const markerIcons = {
  start: {},
  end: {},
  stop: {},
  pickup: {},
  dropoff: {},
};

export const imageMaker = (type) => {
  const icon = new Image();
  icon.src = `${process.env.REACT_APP_HOST}/assets/markers/${type}.png`;
  return icon;
};

["pickup", "dropoff", "current-pickup", "current-dropoff"].forEach((type) => {
  markerIcons[type] = imageMaker(type);
});

export default markerIcons;
